import { computed, unref } from "@nuxtjs/composition-api";

export const UNGROUPED_BUCKET_ID = null;

export function bucketFaqsByGroup(faqs, { otherBucketName } = {}) {
  if (!Array.isArray(faqs) || faqs.length === 0) {
    return [];
  }

  const groupMap = new Map();
  const ungrouped = [];

  for (const faq of faqs) {
    if (faq.group?.id != null) {
      const key = String(faq.group.id);
      if (!groupMap.has(key)) {
        groupMap.set(key, {
          id: faq.group.id,
          name: faq.group.name,
          orderIndex: faq.group.orderIndex ?? 0,
          faqs: [],
        });
      }
      groupMap.get(key).faqs.push(faq);
    } else {
      ungrouped.push(faq);
    }
  }

  const buckets = Array.from(groupMap.values()).sort(
    (a, b) => a.orderIndex - b.orderIndex
  );

  if (ungrouped.length > 0) {
    buckets.push({
      id: UNGROUPED_BUCKET_ID,
      name: otherBucketName ?? "",
      orderIndex: Number.POSITIVE_INFINITY,
      faqs: ungrouped,
    });
  }

  return buckets;
}

export default function useFaqGroupedBuckets(faqsSource, options = {}) {
  return computed(() =>
    bucketFaqsByGroup(unref(faqsSource), {
      otherBucketName: unref(options.otherBucketName),
    })
  );
}
